import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AuthService } from './core/services/auth.service';
import { instalarFetch401Handler } from './core/interceptors/fetch-401.handler';
import { AnalyticsService } from './core/services/analytics.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  template: `<router-outlet></router-outlet>`,
})
export class App {
  constructor(private auth: AuthService, private analytics: AnalyticsService) {
    // Red de seguridad global: cualquier fetch() directo que reciba 401
    // (componentes admin que no usan HttpClient) cierra sesion y va a /login.
    instalarFetch401Handler(this.auth);
    this.analytics.iniciar();
  }
}
